import { ReviewRatingFilters } from 'modules/review/review.enum';
import { ApiSortingDirection } from 'interfaces/api.interface';

export enum ReviewQueryParams {
    type = 'typ',
    rating = 'filtr',
    sorting = 'sortowanie',
    pagination = 'strona'
}

export enum AddReviewQueryParams {
    orderNumberHint = 'trans_id',
    emailHint = 'e',
    opiconnectUserLogin = 'opiconnect_user_login'
}

export enum ReviewQueryRatingValues {
    all = 'wszystkie',
    positive = 'pozytywne',
    neutral = 'neutralne',
    negative = 'negatywne',
    credible = 'wiarygodne'
}

export const filterMap = {
    wszystkie: ReviewRatingFilters.ALL,
    pozytywne: ReviewRatingFilters.POSITIVE,
    neutralne: ReviewRatingFilters.NEUTRAL,
    negatywne: ReviewRatingFilters.NEGATIVE,
    wiarygodne: ReviewRatingFilters.CREDIBLE
};

export const sortFieldsMap: Record<string, string> = {
    ocena: 'averageRating',
    data: 'createdAt'
};

export const sortDirectionMap: Record<string, ApiSortingDirection> = {
    rosnaco: ApiSortingDirection.asc,
    malejaco: ApiSortingDirection.desc
};
